export default __webpack_public_path__ + "static/media/fudr-paid.743c8958.svg";